'use strict';

$(document).on('click', '.leave-site', function () {
    alert($(this).attr('data-msg')); // eslint-disable-line
});
